document.addEventListener('DOMContentLoaded', function() {
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  const fieldMap = {
    'utm_source':   'input[name="contact[utm_source]"]',
    'utm_medium':   'input[name="contact[utm_medium]"]',
    'utm_campaign': 'input[name="contact[utm_campaign]"]',
    'utm_content':  'input[name="contact[utm_content]"]',
    'utm_term':     'input[name="contact[utm_term]"]',
    'gclid':        'input[name="contact[gclid]"]',
    'fbclid':       'input[name="contact[fbclid]"]',
    'page_url':     'input[name="contact[page_url]"]',
  };

  Object.keys(fieldMap).forEach(param => {
    const value = getParam(param);
    if (value) {
      localStorage.setItem(param, value);
      console.log(`[SF] Gespeichert: ${param} =`, value);
    }
  });

  function setField(selector, value) {
    const field = document.querySelector(selector);
    if (!field) {
      console.warn(`[SF] Feld nicht gefunden: ${selector}`);
      return;
    }
    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    console.log(`[SF] Gesetzt: ${selector} =`, value);
  }

  function fillFields() {
    Object.entries(fieldMap).forEach(([param, selector]) => {
      const value = param === 'page_url'
        ? window.location.href
        : localStorage.getItem(param) || getParam(param);

      if (!value) {
        console.log(`[SF] Kein Wert für: ${param}`);
        return;
      }
      setField(selector, value);
    });
  }

  const maxAttempts = 20;
  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;
    const anyFound = Object.values(fieldMap).some(sel => document.querySelector(sel));
    if (anyFound || attempts >= maxAttempts) {
      clearInterval(interval);
      fillFields();
    }
  }, 200);
});